import { render, staticRenderFns } from "./EditStaffBox.vue?vue&type=template&id=8d8c5ac0&scoped=true"
import script from "./EditStaffBox.vue?vue&type=script&lang=js"
export * from "./EditStaffBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8c5ac0",
  null
  
)

export default component.exports